import { Check, Clear, Close, KeyboardArrowLeft } from "@mui/icons-material";
import {
    AppBar,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    Skeleton,
    styled,
    useTheme,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import BasicTableView1 from "../../../../Components/BasicTableView1";



const StyledHeaderTitle = styled(DialogTitle)(({ theme }) => ({
    background: theme.palette.primary.main,
    color: "#fff",
    position: "relative",
    "& button": {
        position: "absolute",
        right: "15px",
        top: "15px",
        color: "#fff",
    },
}));

const FlexContent = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    fontSize: "17px",
    marginBottom: "10px",
    alignItems: "flex-start",
}));

const FlexInnerTitle = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minWidth: "210px",
    maxWidth: "320px",
    fontWeight: "600",
}));

const Values = styled("div")(({ theme }) => ({
    marginLeft: "15px",
    fontWeight: "500",
    color: theme.palette.primary.dark,
    "& input": {
        padding: "10px",
        width: "150px",
    },
    "& .MuiSelect-select": {
        padding: "10px",
    },
    "& button": {
        padding: "11px !important",
        minWidth: "40px",
    },
}));


const AppBarTabs = styled(AppBar)(({ theme }) => ({
    background: "#fff",
    color: theme.palette.primary.dark,
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
    };
}

const ViewContainer = (props) => {

    const theme = useTheme();
    const [value, setValue] = useState(0);

    const [dialogDetails, setDialogDetails] = useState({
        open: true,
    });
    const [productDetails, setProductDetails] = useState("");


    useEffect(() => {
        props.sendDetails(dialogDetails);

    }, [props, dialogDetails]);


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleClose = () => {
        setDialogDetails({
            ...dialogDetails,
            open: false,
        });
    };

    const handleView = (row) => {
        setProductDetails(row);
    };

    const handleBack = () => {
        setProductDetails("");
    };

    const productColumns = [
        { id: "stockCode", name: "Stock Code" },
        { id: "availableQty", name: "Available Qty" },
        { id: "reservedQty", name: "Reserved Qty" },
        { id: "totalQty", name: "Total Qty" },
        { id: "location", name: "Location" },
        { id: "synCareActualSoh", name: "SynCare Actual SOH" },
    ];

    const orderColumns = [
        { id: "orderID", name: "Order ID" },
        { id: "stockCode", name: "Stock Code" },
        { id: "quantity", name: "Quantity" },

    ];

    return (
        <div>
            <Dialog
                open={dialogDetails.open}
                onClose={handleClose}
                maxWidth="xl"
                fullWidth
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <StyledHeaderTitle id="alert-dialog-title">
                    <div>{`View Container Details (${props.viewDetails?.containerDetails?.containerName || "-"
                        })`}</div>
                    <IconButton onClick={handleClose}>
                        <Close />
                    </IconButton>
                </StyledHeaderTitle>
                {props.singleLoading ? (
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Box p={3} sx={{ width: "100%" }}>
                                    <Skeleton height={40} />
                                    <Skeleton height={40} />
                                    <Skeleton height={40} />
                                    <Skeleton height={40} />
                                    <Skeleton height={40} />
                                    <Skeleton height={40} />
                                    <Skeleton height={40} />
                                    <Skeleton height={40} />
                                    <Skeleton height={40} />
                                </Box>
                            </Grid>


                        </Grid>
                    </DialogContent>
                ) : (
                    <DialogContent style={{ margin: "0", padding: "0" }}>
                        <AppBarTabs position="static">
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                indicatorColor="secondary"
                                textColor="inherit"
                                variant="fullWidth"
                                aria-label="full width tabs example"
                            >
                                <Tab label="Container Details" {...a11yProps(0)} />
                                <Tab label="Container SKU Details" {...a11yProps(1)} />
                                <Tab label="Order Details" {...a11yProps(2)} />

                            </Tabs>
                        </AppBarTabs>

                        <TabPanel value={value} index={0} dir={theme.direction}>

                            <Box p={3}>
                                <Grid container spacing={2}>
                                    {/* Left Side */}
                                    <Grid item xs={12} md={6}>


                                        <FlexContent>
                                            <FlexInnerTitle>
                                                <span>Container Name</span> <span> : </span>
                                            </FlexInnerTitle>
                                            <Values>
                                                {props.viewDetails.containerDetails?.containerName}
                                            </Values>
                                        </FlexContent>

                                        <FlexContent>
                                            <FlexInnerTitle>
                                                <span>Status</span> <span> : </span>
                                            </FlexInnerTitle>
                                            <Values>
                                                {props.viewDetails.containerDetails?.status}
                                            </Values>
                                        </FlexContent>
                                        <FlexContent>
                                            <FlexInnerTitle>
                                                <span>Inbound Shipment</span> <span> : </span>
                                            </FlexInnerTitle>
                                            <Values>
                                                {props.viewDetails.containerDetails?.ponNum}
                                            </Values>
                                        </FlexContent>

                                        <FlexContent>
                                            <FlexInnerTitle>
                                                <span> Customer Dispatch Date</span> <span> : </span>
                                            </FlexInnerTitle>
                                            <Values>
                                                {props.viewDetails.containerDetails?.cusDispatchDate !==
                                                    "0000-00-00 00:00:00"
                                                    ? props.viewDetails.containerDetails?.cusDispatchDate !== null
                                                        ? moment(props.viewDetails.containerDetails?.cusDispatchDate).format(
                                                            "ddd, MMM Do YYYY"
                                                        )
                                                        : "-"
                                                    : "-"}
                                            </Values>
                                        </FlexContent>
                                        {props.viewDetails.containerDetails?.tpwRfpDate !== null && (
                                            <FlexContent>
                                                <FlexInnerTitle>
                                                    <span> TPW RFP Date</span> <span> : </span>
                                                </FlexInnerTitle>
                                                <Values>
                                                    {props.viewDetails.containerDetails?.tpwRfpDate !==
                                                        "0000-00-00 00:00:00"
                                                        ? props.viewDetails.containerDetails?.tpwRfpDate !== null
                                                            ? moment(props.viewDetails.containerDetails?.tpwRfpDate).format(
                                                                "ddd, MMM Do YYYY"
                                                            )
                                                            : "-"
                                                        : "-"}
                                                </Values>
                                            </FlexContent>
                                        )}


                                    </Grid>
                                </Grid>
                            </Box>
                        </TabPanel>

                        {/* CSV Details */}
                        <TabPanel value={value} index={1} dir={theme.direction}>

                            <BasicTableView1
                                columns={productColumns}
                                rows={props.viewDetails.containerSkuDetails}

                            //handleView={handleView}
                            />

                        </TabPanel>
                        <TabPanel value={value} index={2} dir={theme.direction}>

                            <BasicTableView1
                                columns={orderColumns}
                                rows={props.viewDetails.orderDetails}

                            //handleView={handleView}
                            />

                        </TabPanel>

                        {/* CSV Details */}
                    </DialogContent>
                )}
                <DialogActions>
                    <Button onClick={handleClose} variant="outlined" color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ViewContainer;
